import { h, Fragment } from 'preact'
import { useState } from 'preact/compat'
import { useTranslations } from '../../../hooks/useTranslations'
import './styles.scss'
import { getPaymentQrCode } from '../../../api/payQrCode.js'

export default function PaymentQrCode() {
  const l10n = useTranslations()
  const [showQrCode, setShowQrCode] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [code, setQrCode] = useState('')
  const urlParams = new URLSearchParams(window.location.search)
  const isGenerated = !!urlParams.get('isGenerated')
  const getQrCode = async () => {
    setIsLoading(true)
    await getPaymentQrCode().then(res => setQrCode(res))
    setIsLoading(false)
    setShowQrCode(true)
  }
  return (
    <>
      {!isGenerated && (
        <tui-payments-qr-code className="payment-qr-code mfe-component">
          {showQrCode ? (
            <img
              className="payment-qr-code__img"
              src={code}
              alt="qr-code"
            />
          ) : (
            <div>
              <button
                type="button"
                className="button primary medium action-button"
                data-testid="create-qr-code"
                disabled={isLoading}
                onClick={getQrCode}
              >
                {l10n.t('Generate QR Code')}
              </button>
            </div>
          )}
        </tui-payments-qr-code>
      )}
    </>
  )
}
